const events = window.hanabi2026Events || [];
const tabs = document.querySelectorAll(".hanabi-js-filter-tab");
const monthTabs = document.querySelectorAll(".hanabi-js-month-tab");
const grid = document.querySelector("#scheduleGrid");
const upcomingList = document.querySelector("#upcomingList");
const loadMoreButton = document.querySelector("#loadMoreButton");
const currentMonthLabel = `${new Date().getMonth() + 1}月`;
const initialVisibleCount = 15;
const visibleStep = 15;
let visibleCount = initialVisibleCount;
const filters = {
  area: "all",
  month: "all"
};

document.querySelectorAll('.hanabi-js-page a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", (event) => {
    const targetId = anchor.getAttribute("href");

    if (!targetId || targetId === "#") {
      return;
    }

    const target = document.querySelector(targetId);

    if (!target) {
      return;
    }

    event.preventDefault();
    target.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  });
});

const formatShortDate = (event) => {
  if (!event.date) {
    return { label: event.month, weekday: event.weekday };
  }

  const [, month, day] = event.date.split("-");
  return {
    label: `${Number(month)}/${Number(day)}`,
    weekday: event.weekday
  };
};

const formatPrefectureBadge = (prefecture) => {
  if (prefecture === "北海道") {
    return prefecture;
  }

  return prefecture.replace(/[都府県]$/, "");
};

const eventCardTemplate = (event) => `
  <article class="hanabi-js-event-card${event.tags?.includes("名物大会") || event.tags?.includes("全国区") ? " hanabi-js-featured" : ""}" data-area="${event.area}">
    <div class="hanabi-js-date-box">
      <span>${event.month}</span>
      <strong>${event.day}</strong>
      <small>${event.weekday}</small>
    </div>
    <div class="hanabi-js-event-body">
      <div class="hanabi-js-event-meta">
        <span>${event.prefecture}</span>
        <span>${event.scale}</span>
        <span>${event.status}</span>
      </div>
      <h3>${event.name}</h3>
      <p>${event.venue}</p>
      ${event.date ? "" : `<p class="hanabi-js-date-note">${event.dateText}</p>`}
      <div class="hanabi-js-tag-row">
        ${(event.tags || []).map((tag) => `<span>${tag}</span>`).join("")}
      </div>
    </div>
  </article>
`;

const renderEvents = () => {
  const visibleEvents = events.filter((event) => {
    const areaMatch = filters.area === "all" || event.area === filters.area;
    const monthMatch = filters.month === "all" || event.month === filters.month;
    return areaMatch && monthMatch;
  });
  const displayedEvents = visibleEvents.slice(0, visibleCount);

  grid.innerHTML = visibleEvents.length
    ? displayedEvents.map(eventCardTemplate).join("")
    : '<p class="hanabi-js-empty-state">該当する花火大会はありません。</p>';

  loadMoreButton.hidden = displayedEvents.length >= visibleEvents.length;
  loadMoreButton.textContent = `もっと見る（${displayedEvents.length}/${visibleEvents.length}件）`;
};

const renderUpcoming = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const upcomingEvents = events
    .filter((event) => event.date && new Date(`${event.date}T00:00:00`) >= today)
    .slice(0, 3);

  if (!upcomingEvents.length) {
    upcomingList.innerHTML = '<p class="hanabi-js-upcoming-empty">今後の開催予定は確認中です。</p>';
    return;
  }

  upcomingList.innerHTML = upcomingEvents
    .map((event) => {
      const date = formatShortDate(event);

      return `
        <a class="hanabi-js-upcoming-card" href="#schedule">
          <time datetime="${event.date}">
            <span>${date.label}</span>
            <small>${date.weekday}</small>
          </time>
          <div class="hanabi-js-upcoming-body">
            <h3>${event.name}</h3>
            <span class="hanabi-js-prefecture">${formatPrefectureBadge(event.prefecture)}</span>
            <p>${event.venue}</p>
          </div>
          <span class="hanabi-js-arrow" aria-hidden="true">→</span>
        </a>
      `;
    })
    .join("");
};

tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    tabs.forEach((item) => item.classList.remove("hanabi-js-active"));
    tab.classList.add("hanabi-js-active");
    filters.area = tab.dataset.filter;
    visibleCount = initialVisibleCount;
    renderEvents();
  });
});

monthTabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    monthTabs.forEach((item) => item.classList.remove("hanabi-js-active"));
    tab.classList.add("hanabi-js-active");
    filters.month = tab.dataset.month;
    visibleCount = initialVisibleCount;
    renderEvents();
  });
});

loadMoreButton.addEventListener("click", () => {
  visibleCount += visibleStep;
  renderEvents();
});

const setInitialMonthFilter = () => {
  const availableMonths = [...new Set(events.map((event) => event.month))]
    .filter((month) => month !== "複数日")
    .sort((a, b) => Number.parseInt(a, 10) - Number.parseInt(b, 10));
  const initialMonth = availableMonths.includes(currentMonthLabel)
    ? currentMonthLabel
    : availableMonths[0] || "all";
  const initialTab = [...monthTabs].find((tab) => tab.dataset.month === initialMonth);

  if (!initialTab) {
    return;
  }

  monthTabs.forEach((tab) => tab.classList.remove("hanabi-js-active"));
  initialTab.classList.add("hanabi-js-active");
  filters.month = initialMonth;
  visibleCount = initialVisibleCount;
};

renderUpcoming();
setInitialMonthFilter();
renderEvents();

